/**
 * TypeScript interfaces for Configuration API response
 * GET /apps/public-websearch-chatbot-client/api/configuration
 */

import { ChatbotPosition, ChatbotIcon, CmsThemeColor } from './customTypes';
import { CHATBOT_CONSTANTS } from '../constants';

/**
 * Raw client settings interface to match the API response from microservice
 */
export interface ClientSettings {
  name: string;
  bubbleText: string;
  welcomeText: string;
  animationEnabled: boolean;
  position: ChatbotPosition;
  color: CmsThemeColor;
  icon: ChatbotIcon;
}

/**
 * Interface for chatbot configuration after API transformation
 * This represents the transformed config object with UI-specific fields
 */
export interface ChatbotConfig {
  name: string;
  bubbleText: string;
  welcomeText: string;
  animationEnabled: boolean;
  position: ChatbotPosition;
  color: CmsThemeColor; // Original enum value
  colorHex: string; // Transformed hex color for UI
  icon: ChatbotIcon;
  iconUrl: string | null; // Custom icon URL when provided
}

/**
 * Interface for CMS theme colors injected by the backend
 * Keys match the CmsThemeColorEnum names from custom types
 */
export interface CmsThemeColors {
  PrimaryColor: string;
  SecondaryColor: string;
  ColorOverPrimary: string;
  ColorOverSecondary: string;
}

/**
 * Interface for the payload of configuration API response
 */
export interface ConfigurationPayload {
  clientSettings: ClientSettings;
  cmsThemeColors: CmsThemeColors; // CMS theme colors (hex values)
}

/**
 * Interface for service metadata in API responses (reused from customTypes)
 */
export interface ServiceResponse {
  errorCode: number;
  errorMessage: string | null;
}

/**
 * Interface for the complete configuration API response
 */
export interface ConfigurationResponse {
  service: ServiceResponse;
  payload: ConfigurationPayload;
}

/**
 * Default configuration values for fallback scenarios
 */
export const DEFAULT_CHATBOT_CONFIG: ClientSettings = {
  name: CHATBOT_CONSTANTS.DEFAULT_NAME,
  bubbleText: CHATBOT_CONSTANTS.DEFAULT_BUBBLE_TEXT,
  welcomeText: CHATBOT_CONSTANTS.DEFAULT_WELCOME_TEXT,
  animationEnabled: true,
  position: ChatbotPosition.BottomRight,
  color: CmsThemeColor.PrimaryColor, // Use enum value instead of hex string
  // colorHex: CHATBOT_CONSTANTS.DEFAULT_COLOR, // Hex color for UI
  icon: ChatbotIcon.Chatbot1,
  // iconUrl: null,
};
